/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Account_Error_DeactivatedInputs */

const en_lib_account_error_deactivated = /** @type {(inputs: Lib_Account_Error_DeactivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account is deactivated`)
};

/**
* | output |
* | --- |
* | "Account is deactivated" |
*
* @param {Lib_Account_Error_DeactivatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_account_error_deactivated = /** @type {((inputs?: Lib_Account_Error_DeactivatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Account_Error_DeactivatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_account_error_deactivated(inputs)
});
export { lib_account_error_deactivated as "lib.account.error.deactivated" }